import React, { useEffect, useState, useRef } from 'react';
import { Mail, Phone, MapPin, Send, Clock, Package, RefreshCw, Briefcase, Calendar, ChevronDown, Gift, MessageSquare, Sparkles, X, Award, Droplets, ShieldCheck } from 'lucide-react';
import gsap from 'gsap';
import './ContactPage.css';
import boutique1 from '../assets/04d1b47f7a9aa37e71ab857d6e511ec8.jpg';
import boutique2 from '../assets/44d94a64-3219-4155-abb3-bc32774c8a88.jpg';
import boutique3 from '../assets/image copy.png';
import boutique4 from '../assets/7005b240f865103ba94dafd7ab3ee36e.jpg';
import shahzaibImg from '../assets/image.png';
import asifImg from '../assets/732a545c-4fcb-4634-a890-dae57c9ef65c.png';

const ContactPage = () => {
  const [formState, setFormState] = useState('idle');
  const [activeTab, setActiveTab] = useState('customer');
  const [faqOpen, setFaqOpen] = useState(null);

  // Quiz State
  const [quizOpen, setQuizOpen] = useState(false);
  const [quizStep, setQuizStep] = useState(1);
  const [quizData, setQuizData] = useState({ gender: '', scent: '', email: '' });

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    company: '',
    quantity: '',
    missingPerfumeName: ''
  });

  const sigRef = useRef(null);
  const [showToast, setShowToast] = useState(false);

  const toastOptions = [
    { name: 'Sarah', city: 'Lahore', time: '2 mins ago', img: 'https://randomuser.me/api/portraits/women/12.jpg' },
    { name: 'Ali', city: 'Karachi', time: '5 mins ago', img: 'https://randomuser.me/api/portraits/men/32.jpg' },
    { name: 'Hina', city: 'Islamabad', time: '12 mins ago', img: 'https://randomuser.me/api/portraits/women/44.jpg' },
    { name: 'Zohaib', city: 'Peshawar', time: '8 mins ago', img: 'https://randomuser.me/api/portraits/men/45.jpg' },
    { name: 'Fatima', city: 'Tank', time: '1 min ago', img: 'https://randomuser.me/api/portraits/women/65.jpg' },
    { name: 'Umer', city: 'Faisalabad', time: '15 mins ago', img: 'https://randomuser.me/api/portraits/men/1.jpg' },
    { name: 'Ayesha', city: 'Multan', time: 'Just Now', img: 'https://randomuser.me/api/portraits/women/2.jpg' },
    { name: 'Bilal', city: 'Quetta', time: '4 mins ago', img: 'https://randomuser.me/api/portraits/men/3.jpg' },
    { name: 'Sana', city: 'Sialkot', time: '22 mins ago', img: 'https://randomuser.me/api/portraits/women/4.jpg' },
    { name: 'Hamza', city: 'Gujranwala', time: 'Just Now', img: 'https://randomuser.me/api/portraits/men/5.jpg' },
    { name: 'Zainab', city: 'Hyderabad', time: '10 mins ago', img: 'https://randomuser.me/api/portraits/women/6.jpg' },
    { name: 'Saad', city: 'Rawalpindi', time: '7 mins ago', img: 'https://randomuser.me/api/portraits/men/7.jpg' },
    { name: 'Maria', city: 'Bahawalpur', time: '18 mins ago', img: 'https://randomuser.me/api/portraits/women/8.jpg' },
    { name: 'Kamran', city: 'Sargodha', time: '30 mins ago', img: 'https://randomuser.me/api/portraits/men/9.jpg' },
    { name: 'Ibrahim', city: 'Sukkur', time: '5 mins ago', img: 'https://randomuser.me/api/portraits/men/10.jpg' },
    { name: 'Nida', city: 'Larkana', time: '12 mins ago', img: 'https://randomuser.me/api/portraits/women/11.jpg' },
    { name: 'Usman', city: 'Sheikhupura', time: '2 mins ago', img: 'https://randomuser.me/api/portraits/men/13.jpg' },
    { name: 'Amber', city: 'Rahim Yar Khan', time: 'Just Now', img: 'https://randomuser.me/api/portraits/women/14.jpg' },
    { name: 'Fahad', city: 'Jhang', time: '45 mins ago', img: 'https://randomuser.me/api/portraits/men/15.jpg' },
    { name: 'Mehak', city: 'Dera Ghazi Khan', time: '9 mins ago', img: 'https://randomuser.me/api/portraits/women/16.jpg' },
    { name: 'Tayyab', city: 'Mardan', time: '14 mins ago', img: 'https://randomuser.me/api/portraits/men/17.jpg' },
    { name: 'Sidra', city: 'Kasur', time: '3 mins ago', img: 'https://randomuser.me/api/portraits/women/18.jpg' }
  ];
  const [currentToast, setCurrentToast] = useState(toastOptions[0]);

  useEffect(() => {
    const showRandomToast = () => {
      const random = toastOptions[Math.floor(Math.random() * toastOptions.length)];
      setCurrentToast(random);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 7000); // Show for 7 seconds
    };

    // Show first toast after 5s
    const timer = setTimeout(showRandomToast, 5000);

    // Repeat every 60s (1 minute)
    const interval = setInterval(showRandomToast, 60000);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    const ctx = gsap.context(() => {
      gsap.from('.contact-header h1', { y: 60, opacity: 0, duration: 1.2, ease: 'power4.out' });
      gsap.from('.founder-signature-wrap', { opacity: 0, x: -30, duration: 1.5, delay: 0.8, ease: 'power2.out' });

      gsap.to('.glow-1', { x: '20%', y: '10%', duration: 8, ease: 'sine.inOut', repeat: -1, yoyo: true });
      gsap.to('.glow-2', { x: '-20%', y: '-10%', duration: 10, ease: 'sine.inOut', delay: 1, repeat: -1, yoyo: true });
      gsap.to('.glow-3', { scale: 1.2, opacity: 0.3, duration: 12, ease: 'sine.inOut', delay: 2, repeat: -1, yoyo: true });
    });

    // ── AUTOMATIC ADMIN ALERT LOGIC ──
    const urlParams = new URLSearchParams(window.location.search);
    const errorType = urlParams.get('error');
    const missingProduct = urlParams.get('missing_product');

    if (errorType || missingProduct) {
      const triggerAlert = async () => {
        try {
          await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              access_key: "7a72250f-39e4-4706-b19d-77ac7c6cc8ea",
              subject: "User Issue / Product Not Found Alert",
              message: `AUTOMATED ALERT:\n\nType: ${errorType ? 'System/API Error' : 'Missing Product'}\nDetails: ${errorType || missingProduct}\nTimestamp: ${new Date().toLocaleString()}\nUser Page: ${window.location.href}`,
              from_name: "Escentrum System Alert"
            }),
          });
          console.log("Admin alerted regarding issue.");
        } catch (err) { console.error("Alert failed", err); }
      };
      triggerAlert();
    }

    return () => ctx.revert();
  }, []);

  // Magnetic Button Effect
  const handleMagneticMove = (e) => {
    const btn = e.currentTarget;
    const rect = btn.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    gsap.to(btn, { x: x * 0.4, y: y * 0.4, duration: 0.3, ease: 'power2.out' });
  };

  const handleMagneticLeave = (e) => {
    const btn = e.currentTarget;
    gsap.to(btn, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1, 0.3)' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormState('sending');
    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          access_key: "7a72250f-39e4-4706-b19d-77ac7c6cc8ea",
          name: formData.name, email: formData.email, subject: formData.subject,
          company: formData.company, quantity: formData.quantity, 
          message: `Missing Perfume Name: ${formData.missingPerfumeName || 'N/A'}\n\nUser Message: ${formData.message}`, 
          type: activeTab
        }),
      });
      const result = await response.json();
      if (result.success) {
        setFormState('success');
        setFormData({ name: '', email: '', subject: '', message: '', company: '', quantity: '' });
      } else {
        alert("Failed to send message. Please try again.");
        setFormState('idle');
      }
    } catch (error) {
      alert("An error occurred while sending the message.");
      setFormState('idle');
    }
  };

  const handleQuizSubmit = async () => {
    try {
      await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          access_key: "7a72250f-39e4-4706-b19d-77ac7c6cc8ea",
          subject: "New Fragrance Quiz Submission",
          email: quizData.email,
          message: `User is looking for a fragrance.\nGender: ${quizData.gender}\nPreference: ${quizData.scent}`
        }),
      });
      setQuizStep(4); // Success step
    } catch (err) { console.log(err); }
  };

  const toggleFaq = (index) => {
    setFaqOpen(faqOpen === index ? null : index);
  };

  const faqs = [
    { q: "How long does delivery take?", a: "Standard delivery takes 3-5 business days. Express shipping is available for 1-2 day delivery." },
    { q: "Are your fragrances long-lasting?", a: "Yes, all our perfumes are Extrait de Parfum or Eau de Parfum, crafted with a high concentration of premium oils to last 12+ hours." },
    { q: "What is your return policy?", a: "We offer a 14-day return policy on unopened and unused products." },
    { q: "Do you offer bespoke or custom perfumes?", a: "Yes, you can book a Signature Scent Fitting consultation with our experts to create a custom fragrance." }
  ];

  return (
    <div className="contact-page glass-theme">
      {/* ── QUIZ MODAL ── */}
      {quizOpen && (
        <div className="quiz-overlay">
          <div className="quiz-modal glass-card">
            <button className="close-quiz" onClick={() => { setQuizOpen(false); setQuizStep(1); }}><X /></button>
            <div className="quiz-content">
              {quizStep === 1 && (
                <div className="quiz-step fade-in">
                  <h3>Who are you shopping for?</h3>
                  <div className="quiz-options">
                    <button onClick={() => { setQuizData({ ...quizData, gender: 'Him' }); setQuizStep(2); }}>For Him</button>
                    <button onClick={() => { setQuizData({ ...quizData, gender: 'Her' }); setQuizStep(2); }}>For Her</button>
                    <button onClick={() => { setQuizData({ ...quizData, gender: 'Unisex' }); setQuizStep(2); }}>Unisex</button>
                  </div>
                </div>
              )}
              {quizStep === 2 && (
                <div className="quiz-step fade-in">
                  <h3>What type of scent do you prefer?</h3>
                  <div className="quiz-options">
                    <button onClick={() => { setQuizData({ ...quizData, scent: 'Woody & Musky' }); setQuizStep(3); }}>Woody & Musky</button>
                    <button onClick={() => { setQuizData({ ...quizData, scent: 'Fresh & Citrus' }); setQuizStep(3); }}>Fresh & Citrus</button>
                    <button onClick={() => { setQuizData({ ...quizData, scent: 'Floral & Sweet' }); setQuizStep(3); }}>Floral & Sweet</button>
                  </div>
                </div>
              )}
              {quizStep === 3 && (
                <div className="quiz-step fade-in">
                  <h3>Where should we send your results?</h3>
                  <input type="email" placeholder="Enter your email..." className="quiz-input" value={quizData.email} onChange={(e) => setQuizData({ ...quizData, email: e.target.value })} />
                  <button className="quiz-submit-btn" onClick={handleQuizSubmit} disabled={!quizData.email}>Reveal My Scent</button>
                </div>
              )}
              {quizStep === 4 && (
                <div className="quiz-step fade-in success-step">
                  <Sparkles size={50} color="#d4af37" />
                  <h3>Your perfect match has been found!</h3>
                  <p>Check your email inbox for your personalized Escentrum fragrance recommendation.</p>
                  <button onClick={() => setQuizOpen(false)} className="quiz-submit-btn">Close</button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── BACKGROUND ACCENTS ── */}
      <div className="bg-glows">
        <div className="glow glow-1"></div>
        <div className="glow glow-2"></div>
        <div className="glow glow-3"></div>
      </div>

      {/* ── HERO SECTION ── */}
      <section className="contact-hero glass-theme">
        <video autoPlay loop muted playsInline preload="auto" className="hero-video-bg">
          <source src="https://assets.mixkit.co/videos/preview/mixkit-golden-particles-floating-in-the-air-4872-large.mp4" type="video/mp4" />
        </video>
        <div className="contact-hero-overlay"></div>
        <div className="container relative-z">
          <div className="contact-header">
            <div className="badge-wrap">
              <div className="online-status">
                <div className="status-dot"></div>
                <span>CONCIERGE ONLINE NOW</span>
              </div>
              <span className="contact-tag">LUXURY FRAGRANCE CONCIERGE</span>
            </div>
            <h1>The Art of <span>Scent</span> Discovery</h1>

            {/* CEO Signature text only */}
            <div className="founder-signature-wrap" ref={sigRef}>
              <span className="founder-name">Shahzaib Zaman & Asif Ali Burki</span>
              <span className="founder-title">Founder & CEO, Escentrum</span>
            </div>

            <p className="hero-desc">Experience our bespoke concierge service. From signature scent fittings to private consultations, we are here to curate your olfactory journey.</p>

            <div className="hero-actions">
              <button className="quiz-trigger-btn magnetic-btn" onClick={() => setQuizOpen(true)} onMouseMove={handleMagneticMove} onMouseLeave={handleMagneticLeave}>
                <Sparkles size={18} /> Find Your Signature Scent
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ── DEPARTMENT CARDS ── */}
      <section className="department-section">
        <div className="container">
          <div className="dept-cards">
            {/* Card 1 */}
            <div className="dept-card-container" onClick={() => { setActiveTab('customer'); setFormData({ ...formData, subject: 'Order Tracking' }); window.scrollTo({ top: 1000, behavior: 'smooth' }); }}>
              <div className="dept-card-inner">
                <div className="dept-card-front glass-card">
                  <div className="dept-icon"><Package size={32} /></div>
                  <h3>Track My Order</h3>
                  <p>Check the status of your purchase</p>
                </div>
                <div className="dept-card-back">
                  <Sparkles size={24} />
                  <h3>Where is my scent?</h3>
                  <p>Click to track your royal delivery</p>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="dept-card-container" onClick={() => { setActiveTab('customer'); setFormData({ ...formData, subject: 'Returns' }); window.scrollTo({ top: 1000, behavior: 'smooth' }); }}>
              <div className="dept-card-inner">
                <div className="dept-card-front glass-card">
                  <div className="dept-icon"><RefreshCw size={32} /></div>
                  <h3>Returns & Exchanges</h3>
                  <p>Initiate a return</p>
                </div>
                <div className="dept-card-back">
                  <RefreshCw size={24} />
                  <h3>Hassle Free</h3>
                  <p>100% Satisfaction Guaranteed</p>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="dept-card-container" onClick={() => { setActiveTab('wholesale'); setFormData({ ...formData, subject: 'Partnership' }); window.scrollTo({ top: 1000, behavior: 'smooth' }); }}>
              <div className="dept-card-inner">
                <div className="dept-card-front glass-card">
                  <div className="dept-icon"><Briefcase size={32} /></div>
                  <h3>Press & Partnerships</h3>
                  <p>Wholesale inquiries</p>
                </div>
                <div className="dept-card-back">
                  <Briefcase size={24} />
                  <h3>Partner With Us</h3>
                  <p>Expand the Escentrum legacy</p>
                </div>
              </div>
            </div>

            {/* Card 4 */}
            <div className="dept-card-container highlight-card" onClick={() => window.open("https://wa.me/923401854040?text=Hello%2C%20I%20would%20like%20to%20book%20a%20free%20Fragrance%20Consultation%20to%20find%20my%20Signature%20Scent.%20Please%20let%20me%20know%20your%20available%20timings.", "_blank")}>
              <div className="dept-card-inner">
                <div className="dept-card-front glass-card">
                  <div className="dept-icon gold"><Calendar size={32} /></div>
                  <h3>Book a Consultation</h3>
                  <p>Signature Scent via Video Call</p>
                  <button className="book-btn">Book Now</button>
                </div>
                <div className="dept-card-back">
                  <Calendar size={24} />
                  <h3>Private Fitting</h3>
                  <p>Find your olfactory soulmate</p>
                  <button className="book-btn">Confirm Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CONCIERGE PROCESS ── */}
      <section className="process-section">
        <div className="container">
          <div className="section-head text-center">
            <span className="contact-tag">OUR METHOD</span>
            <h2>The Escentrum <span>Experience</span></h2>
          </div>
          <div className="process-grid">
            {/* Step 1 */}
            <div className="process-step-container">
              <div className="process-step-inner">
                <div className="process-step-front glass-card">
                  <div className="step-icon"><MessageSquare size={32} /></div>
                  <h3>Private Consultation</h3>
                  <p>We begin by understanding your personal scent profile and memories.</p>
                </div>
                <div className="process-step-back">
                  <MessageSquare size={24} color="#d4af37" />
                  <h4>Phase One</h4>
                  <p>A deep dive into your olfactory preferences with our master curators.</p>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="process-step-container">
              <div className="process-step-inner">
                <div className="process-step-front glass-card">
                  <div className="step-icon"><Droplets size={32} /></div>
                  <h3>Olfactory Curation</h3>
                  <p>Our artisans curate a selection of hand-picked fragrances for you.</p>
                </div>
                <div className="process-step-back">
                  <Droplets size={24} color="#d4af37" />
                  <h4>Phase Two</h4>
                  <p>Exclusive access to rare ingredients and signature blends.</p>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="process-step-container">
              <div className="process-step-inner">
                <div className="process-step-front glass-card">
                  <div className="step-icon"><Package size={32} /></div>
                  <h3>Luxury Delivery</h3>
                  <p>Receive your curated signature scents in premium packaging.</p>
                </div>
                <div className="process-step-back">
                  <Package size={24} color="#d4af37" />
                  <h4>Phase Three</h4>
                  <p>White-glove delivery in our signature velvet-lined boxes.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── CONTENT ── */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">

            {/* Left: Info */}
            <div className="contact-info">
              <div className="contact-info-card glass-card">
                <div className="info-icon" style={{ display: 'flex' }}><Mail size={24} /></div>
                <div className="info-body">
                  <h3>Direct Email</h3>
                  <div className="email-links">
                    <a href="https://mail.google.com/mail/?view=cm&fs=1&to=Shahzaibzaman001@gmail.com" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', display: 'block', marginBottom: '10px' }}>Shahzaibzaman001@gmail.com</a>
                  </div>
                  <div className="team-avatars">
                    <div className="avatars-group">
                      <img src={shahzaibImg} alt="Shahzaib Zaman" />
                      <img src={asifImg} alt="Asif Ali Burki" style={{ marginLeft: '-10px' }} />
                    </div>
                    <span>Our experts, Shahzaib & Asif, are here to assist you.</span>
                  </div>

                </div>
              </div>



              <div className="contact-info-card glass-card">
                <a href="tel:03401854040" className="info-icon" style={{ display: 'flex', textDecoration: 'none' }}><Phone size={24} /></a>
                <div className="info-body">
                  <h3>Phone Inquiry</h3>
                  <a href="tel:03401854040" style={{ textDecoration: 'none', display: 'block' }}>0340 185 4040</a>
                </div>
              </div>

              <div className="contact-info-card glass-card">
                <a href="https://www.google.com/maps/dir/?api=1&destination=Afsar+Khan+Plaza,+Tank,+Khyber+Pakhtunkhwa,+Pakistan" target="_blank" rel="noreferrer" className="info-icon" style={{ display: 'flex', textDecoration: 'none' }}><MapPin size={24} /></a>
                <div className="info-body">
                  <h3>Flagship Boutique</h3>
                  <p>Afsar Khan Plaza, 1st Floor, Shop 23</p>
                  <p>Tank, KPK</p>
                  <div className="boutique-gallery">
                    <img src={boutique1} alt="Store 1" />
                    <img src={boutique2} alt="Store 2" />
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Form */}
            <div className="contact-form-wrap glass-card">
              <div className="response-badge">
                <Clock size={14} />
                <span>Average Response Time: <strong>Under 2 Hours</strong></span>
              </div>

              <div className="form-inner">
                {formState === 'success' ? (
                  <div className="form-success premium-success">
                    <Gift size={60} color="#d4af37" className="gift-icon" />
                    <h2>Message Received!</h2>
                    <p>Thank you for contacting Escentrum. Our concierge will respond shortly.</p>
                    <div className="surprise-gift">
                      <span>As a token of our appreciation, enjoy 10% off your next purchase:</span>
                      <div className="gift-code">VIP10</div>
                    </div>
                    <button className="reset-btn" onClick={() => setFormState('idle')}>Send Another Message</button>
                  </div>
                ) : (
                  <>
                    <div className="form-head">
                      <h2>Send An Inquiry</h2>
                      <p>Complete the form below and we will get back to you shortly.</p>
                    </div>

                    <div className="form-tabs">
                      <button type="button" className={`tab-btn ${activeTab === 'customer' ? 'active' : ''}`} onClick={() => setActiveTab('customer')}>Customer Support</button>
                      <button type="button" className={`tab-btn ${activeTab === 'wholesale' ? 'active' : ''}`} onClick={() => setActiveTab('wholesale')}>Business / Wholesale</button>
                    </div>

                    <form onSubmit={handleSubmit}>
                      <div className="form-row">
                        <div className="input-group">
                          <label>Full Name</label>
                          <input type="text" placeholder="John Doe" required value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
                        </div>
                        <div className="input-group">
                          <label>Email Address</label>
                          <input type="email" placeholder="john@example.com" required value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
                        </div>
                      </div>

                      {activeTab === 'wholesale' && (
                        <div className="form-row">
                          <div className="input-group">
                            <label>Company Name</label>
                            <input type="text" placeholder="Your Company LLC" required={activeTab === 'wholesale'} value={formData.company} onChange={(e) => setFormData({ ...formData, company: e.target.value })} />
                          </div>
                          <div className="input-group">
                            <label>Expected Quantity</label>
                            <input type="number" placeholder="e.g. 500" required={activeTab === 'wholesale'} value={formData.quantity} onChange={(e) => setFormData({ ...formData, quantity: e.target.value })} />
                          </div>
                        </div>
                      )}

                      <div className="input-group">
                        <label>Subject</label>
                        <select required value={formData.subject} onChange={(e) => setFormData({ ...formData, subject: e.target.value })}>
                          <option value="">Select a reason</option>
                          {activeTab === 'customer' ? (
                            <>
                              <option value="Product Inquiry">Product Inquiry</option>
                              <option value="Product Not Found">Product Not Found Alert</option>
                              <option value="System Issue">System Issue / Bug Report</option>
                              <option value="Order Tracking">Order Tracking</option>
                              <option value="Returns">Returns & Exchanges</option>
                              <option value="Bespoke Scent">Bespoke Scent Request</option>
                            </>
                          ) : (
                            <>
                              <option value="Wholesale Inquiry">Wholesale Inquiry</option>
                              <option value="Partnership">Partnership / Collab</option>
                              <option value="Press">Press & Media</option>
                            </>
                          )}
                        </select>
                      </div>

                      {/* CONDITIONAL FIELD FOR MISSING PERFUME */}
                      {formData.subject === 'Product Not Found' && (
                        <div className="input-group fade-in">
                          <label>Which perfume are you looking for?</label>
                          <input 
                            type="text" 
                            placeholder="e.g. Royal Oud Intense" 
                            required 
                            value={formData.missingPerfumeName} 
                            onChange={(e) => setFormData({ ...formData, missingPerfumeName: e.target.value })} 
                          />
                        </div>
                      )}
                      <div className="input-group">
                        <label>Message</label>
                        <textarea rows="5" placeholder="How can we assist you today?" required value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })}></textarea>
                      </div>
                      <button type="submit" className={`submit-btn magnetic-btn ${formState === 'sending' ? 'loading' : ''}`} disabled={formState === 'sending'} onMouseMove={handleMagneticMove} onMouseLeave={handleMagneticLeave}>
                        {formState === 'sending' ? <div className="luxury-spinner small"></div> : <><span>SEND MESSAGE</span><Send size={16} /></>}
                      </button>
                    </form>

                    <div className="trust-badges-wrap">
                      <div className="badge-item">
                        <div className="badge-icon"><Award size={24} /></div>
                        <span>Award Winning Blends</span>
                      </div>
                      <div className="badge-item">
                        <div className="badge-icon"><Droplets size={24} /></div>
                        <span>French Ingredients</span>
                      </div>
                      <div className="badge-item">
                        <div className="badge-icon"><ShieldCheck size={24} /></div>
                        <span>Secure Checkout</span>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── MEET THE EXPERTS (EDITORIAL V2) ── */}
      <section className="experts-section-v2">
        <div className="container">
          <div className="experts-header-editorial">
            <div className="h-left">
              <span className="editorial-tag">THE ARTISANS</span>
              <div className="editorial-line"></div>
            </div>
            <div className="h-center">
              <h2 className="editorial-title">Meet Your Scent <br /> <span className="gold-shimmer-text">Curators</span></h2>
            </div>
            <div className="h-right">
              <p className="editorial-desc">The masterminds behind Escentrum. Our artisans combine centuries of heritage with modern olfactory science.</p>
            </div>
          </div>

          <div className="experts-grid-v2">
            <div className="expert-card-v2">
              <div className="expert-card-inner glass-card">
                <div className="expert-image-wrap">
                  <img src={shahzaibImg} alt="Shahzaib Zaman" />
                  <div className="expert-overlay-glow"></div>
                </div>
                <div className="expert-info-v2">
                  <span className="expert-number">01</span>
                  <h4>Shahzaib Zaman</h4>
                  <p>Founder & Master Perfumer</p>
                  <div className="expert-signature-mini">S. Zaman</div>
                </div>
              </div>
            </div>

            <div className="expert-card-v2">
              <div className="expert-card-inner glass-card">
                <div className="expert-image-wrap">
                  <img src={asifImg} alt="Asif Ali Burki" />
                  <div className="expert-overlay-glow"></div>
                </div>
                <div className="expert-info-v2">
                  <span className="expert-number">02</span>
                  <h4>Asif Ali Burki</h4>
                  <p>Managing Director</p>
                  <div className="expert-signature-mini">A.A. Burki</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── BOUTIQUE GALLERY CAROUSEL ── */}
      <section className="gallery-section">
        <div className="container">
          <div className="section-head text-center">
            <span className="contact-tag">INSIDE THE MAISON</span>
            <h2>Our <span>Flagship</span> Boutique</h2>
          </div>
        </div>
        <div className="gallery-carousel-wrap">
          <div className="gallery-track">
            {[boutique1, boutique2, boutique3, boutique4, boutique1, boutique2, boutique3, boutique4].map((img, index) => (
              <div className="gallery-slide" key={index}>
                <img src={img} alt={`Boutique ${index}`} />
                <div className="gallery-overlay"><Sparkles color="#d4af37" /></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── FAQ SECTION ── */}
      <section className="faq-section">
        <div className="container">
          <div className="faq-wrapper">
            <h2>Frequently Asked Questions</h2>
            <div className="faq-accordion glass-card">
              {faqs.map((faq, index) => (
                <div className={`faq-item ${faqOpen === index ? 'open' : ''}`} key={index} onClick={() => toggleFaq(index)}>
                  <div className="faq-q">
                    <h4>{faq.q}</h4>
                    <ChevronDown size={20} className="faq-icon" />
                  </div>
                  <div className="faq-a"><p>{faq.a}</p></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── REAL MAP SECTION ── */}
      <section className="contact-map">
        <div className="map-overlay">
          <div className="map-card glass-card">
            <h3>Visit Our Boutique</h3>
            <p>Experience the royal fragrances in person at our flagship store in Tank.</p>
            <a
              href="https://www.google.com/maps/dir//Afsar+Khan+Plaza,+Tank,+Khyber+Pakhtunkhwa,+Pakistan/"
              target="_blank"
              rel="noreferrer"
              className="directions-link"
            >
              <MapPin size={18} /> GET DIRECTIONS
            </a>
          </div>
        </div>
        <div className="real-map-container">
          <iframe
            src="https://maps.google.com/maps?q=Afsar%20Khan%20Plaza%20Tank%20KPK%20Pakistan&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%" height="100%"
            style={{ border: 0, filter: 'grayscale(0.8) contrast(1.2)' }}
            allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Boutique Location"
          ></iframe>
        </div>
      </section>

      {/* ── SOCIAL PROOF TOAST ── */}
      {showToast && (
        <div className="social-proof-toast">
          <img src={currentToast.img} alt="Customer" className="social-img" />
          <div className="social-content">
            <p><strong>{currentToast.name}</strong> from {currentToast.city} just booked a consultation.</p>
            <span>Verified Booking • {currentToast.time}</span>
          </div>
          <button onClick={() => setShowToast(false)} className="close-quiz" style={{ position: 'static', padding: '5px' }}><X size={14} /></button>
        </div>
      )}
    </div>
  );
};

export default ContactPage;
